import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 10 10',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M5,4.06 L8,7 C8.28680645,7.13697654 8.62880852,7.07829826 8.85355339,6.85355339 C9.07829826,6.62880852 9.13697654,6.28680645 9,6 L5.5,2.5 C5.20718245,2.20754662 4.73281755,2.20754662 4.44,2.5 L1,6 C0.86302346,6.28680645 0.921701738,6.62880852 1.14644661,6.85355339 C1.37119148,7.07829826 1.71319355,7.13697654 2,7 L5,4.06 Z"
        fill={fill}
        fillRule="nonzero"
      />
    </g>
  </svg>
);
export default SVG;
